import React, {useContext, useState, useEffect} from 'react';
import {Block} from '../block';
import {ParameterTable} from './parameter-table';
import {OpenApiContext} from '../../openapi-context';
import {omit, merge, remove} from 'lodash';
import classnames from 'classnames';

export function ParametersBlock({parameters, className, onSave, onCancel, mobile}) {
    const classes = classnames(className);
    const [editMode, setEditMode] = useState();
    const [editedParameters, setEditedParameters] = useState([]);
    const {dispatch} = useContext(OpenApiContext);

    useEffect(() => {
        setEditedParameters([...(parameters || [])]);
    }, [parameters]);

    function handleSave() {
        dispatch({type: 'terminate'});
        setEditMode(false);
        return onSave && onSave({parameters: editedParameters.map((p) => omit(p, 'key', 'tags', 'type'))});
    }

    function handleCancel() {
        dispatch({type: 'terminate'});
        setEditMode(false);
        setEditedParameters([...(parameters || [])]);
        return onCancel && onCancel();
    }

    const triggerEdit = () => {
        setEditMode(true);
        dispatch({type: 'activate', message: 'changes to parameters'});
    };

    function handleOnChange(changeSet) {
        switch (changeSet.type) {
            case 'update-param':
                const targetParam = editedParameters.find((p) => p.name === changeSet.name);
                if (targetParam) {
                    if (changeSet.tags) {
                        targetParam.required = !!changeSet.tags.find((t) => t.text === 'required');
                        targetParam.allowEmptyValue = !!changeSet.tags.find((t) => t.text === 'allowEmptyValue');
                        targetParam.deprecated = !!changeSet.tags.find((t) => t.text === 'deprecated');
                    } else {
                        merge(targetParam, changeSet.fields);
                    }
                }
                break;
            case 'rm-op-parameter':
                remove(editedParameters, (p) => p.name === changeSet.name);
                setEditedParameters([...editedParameters]);
                break;
            case 'param-rename':
                console.log('param renaming', changeSet);
                const param = editedParameters.find((p) => p.name === changeSet.from);
                if (param) {
                    param.name = changeSet.to;
                }
                setEditedParameters([...editedParameters]);
                break;
            case 'add-op-parameter':
                setEditedParameters([
                    ...editedParameters,
                    ...changeSet.param.map((param) => {
                        if (param.$ref) {
                            const newParam = {
                                $ref: param.$ref,
                            };
                            return newParam;
                        } else {
                            return {
                                name: param.name,
                                schema: {
                                    type: param.type || 'string',
                                },
                                in: param.in || 'path',
                            };
                        }
                    }),
                ]);
                break;
        }
    }

    return editedParameters ? (
        <Block className={classes} onCancel={handleCancel} onSave={handleSave} onEdit={triggerEdit} mobile={mobile}>
            {/* No inner ToggleSection: the Path Params drawer (in interface-view)
                is already the disclosure affordance. An extra collapse chevron
                here costs a click with no information gain. */}
            <ParameterTable parameters={editedParameters} editMode={editMode} onChange={handleOnChange} />
        </Block>
    ) : null;
}
